import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

interface GetInvitationUrlParams {
  clientId: string;
  email: string;
}

const getInvitationUrl = ({
  clientId,
  email,
}: GetInvitationUrlParams): Promise<{ InvitationUrl: string }> => {
  return authFetch(urlWithParams('/Consumer/ConsumerEmailUpdate/GetInvitationUrl', { clientId, email }), {
    method: 'POST',
  });
};

export const useGetInvitationUrlMutation = () => {
  return useMutation(getInvitationUrl);
};
